import { IMG_EMPTY_STATE } from "~/utils/url/staticResources";
import { InformationPage } from "~/common/components/informationPage/InformationPage";
import { useTranslation } from "react-i18next";

interface Props {
  onCreateWishlist: () => void;
}

export const NoWishlistContent = ({ onCreateWishlist }: Props) => {
  const { t } = useTranslation();

  return (
    <InformationPage.CenterContents className={"pb-30"}>
      <InformationPage.Title>{t("page.wishlist.noWishlist.title")}</InformationPage.Title>
      <InformationPage.Image src={IMG_EMPTY_STATE} />
      <InformationPage.CtaButton onClick={onCreateWishlist} data-test-id={"btn-create-wishlist"}>
        {t("page.wishlist.button.create")}
      </InformationPage.CtaButton>
      <InformationPage.GoHomepageLink />
    </InformationPage.CenterContents>
  );
};
